import React from "react";

interface PageLoadingStateProps {
  message?: string;
}

/**
 * Reusable loading state component for pages
 * Shows a spinner with an optional message
 */
export function PageLoadingState({ message = "Loading..." }: PageLoadingStateProps) {
  return (
    <div className="h-full flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600 text-center">{message}</p>
      </div>
    </div>
  );
}

